"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTljPidUseInfo = getTljPidUseInfo;
var _request = _interopRequireDefault(require("@/utils/request"));
// 订单管理
function getTljPidUseInfo(data) {
  return (0, _request.default)({
    url: '/portal/system/tlj/getTljPidUseInfo',
    method: 'post',
    data: data
  });
}